export const localStoragekey = "sfl_user_data";

export const getUserData = (key) => {
  return new Promise((resolve, reject) => {
    let userData = JSON.parse(localStorage.getItem(key));
    // console.log("getuserdata called", userData)
    if (userData) {
      resolve(userData);
    } else {
      reject({});
    }
  });
};

export const setUserData = (userData, key) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify(userData);
    localStorage.setItem(key, data);

    localStorage.setItem("OrderUserDataLogin", data);
    resolve(true);
  });
};
